import { render } from "./ServiceComponent.vue?vue&type=template&id=20a96195"
import script from "./ServiceComponent.vue?vue&type=script&lang=js"
export * from "./ServiceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__